export default __webpack_public_path__ + "static/media/general-bg-light-top.30d39777.svg";